// Навигация предпросмотра: какой урок смотрим и на каком языке (п.5 правок
// 29 августа). Раньше и то и другое приходилось менять снаружи — закрыть
// диалог, выбрать урок в таймлайне, открыть предпросмотр заново.
import {
  SegmentedControl,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@teach/ui'
import type { CourseWithoutBlocks } from '@/types/course'
import type { ContentLang } from '@/features/editor/editorSlice'
import { LANG_LABEL } from '@/features/editor/lib/contentLangLabels'
import { pickLangField } from '@/lib/localizedText'
import { useMessages } from '@/i18n'
import { messages } from './messages'

const LANGS: ContentLang[] = ['ru', 'en']

interface Props {
  lessons: CourseWithoutBlocks['lessons']
  lessonId: number | null
  onLessonChange: (id: number) => void
  lang: ContentLang
  onLangChange: (lang: ContentLang) => void
  /** У курса есть второй языковой слот. Без него переключатель не показываем:
   *  он предлагал бы язык, на котором в уроке нет ни строчки. */
  hasSecondLang: boolean
}

export const PreviewHeaderControls = ({
  lessons,
  lessonId,
  onLessonChange,
  lang,
  onLangChange,
  hasSecondLang,
}: Props) => {
  const m = useMessages(messages)
  return (
    <div className="flex items-center gap-2">
      <Select
        value={lessonId === null ? undefined : String(lessonId)}
        onValueChange={(v) => onLessonChange(Number(v))}
      >
        <SelectTrigger aria-label={m.lesson} className="h-8 w-56">
          <SelectValue placeholder={m.lesson} />
        </SelectTrigger>
        <SelectContent>
          {lessons.map((lesson, index) => (
            <SelectItem key={lesson.id} value={String(lesson.id)}>
              {`${index + 1}. ${pickLangField(lesson.name, lesson.nameEn, lang) || m.untitled}`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {hasSecondLang ? (
        <SegmentedControl
          size="sm"
          value={lang}
          onChange={onLangChange}
          options={LANGS.map((id) => ({ id, label: LANG_LABEL[id] }))}
        />
      ) : null}
    </div>
  )
}
